import { render, staticRenderFns } from "./Paperlayout.vue?vue&type=template&id=45dfa8f2&scoped=true"
import script from "./Paperlayout.vue?vue&type=script&lang=js"
export * from "./Paperlayout.vue?vue&type=script&lang=js"
import style0 from "./Paperlayout.vue?vue&type=style&index=0&id=45dfa8f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dfa8f2",
  null
  
)

export default component.exports